import { render, staticRenderFns } from "./trafficCalculator.vue?vue&type=template&id=52093f31&scoped=true"
import script from "./trafficCalculator.vue?vue&type=script&lang=js"
export * from "./trafficCalculator.vue?vue&type=script&lang=js"
import style0 from "./trafficCalculator.vue?vue&type=style&index=0&id=52093f31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52093f31",
  null
  
)

export default component.exports